import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_CONDITION } from "./abstract/conditionAbstract";

const _action = `${ACTION_PREFIX_CONDITION}_move_flat`;
const _header = `Move condition`;

export const moveConditionFlat = (root, id, idDestinationParent, indexDestination) => {
  const _payload = moveConditionLogic(root, id, idDestinationParent, indexDestination);

  logger.logAction(_action, _payload, ACTION_PREFIX_CONDITION);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const moveConditionLogic = (root, id, idDestinationParent, indexDestination) => {
  const _idParent = pathUtils.getIdParent(id);
  const { data: _node, index: _index } = getNodeById(root, id);

  if (!_node) {
    throw new Error("Condition to move not found");
  }

  const { data: _nodeParent } = getNodeById(root, _idParent);
  const { data: _nodeDestinationParent } = getNodeById(root, idDestinationParent);

  if (!_nodeDestinationParent) {
    throw new Error("Destination parent node not found");
  }
  
  const { data: _nodeCopy } = nodeUtils.copy(_node, { idParent: idDestinationParent });

  const _indexParsed =
    indexDestination ??
    (_idParent === idDestinationParent
      ? nodeUtils.getConditions(_nodeDestinationParent).length - 1
      : nodeUtils.getConditions(_nodeDestinationParent).length);

  const _nodeBackup = systemUtils.createDeepCopy(_node);

  detachNode(_nodeParent, id);
  attachNode(_nodeDestinationParent, _nodeCopy, _indexParsed);

  return generatePayload(_nodeBackup, _index, _nodeParent, _nodeDestinationParent, _indexParsed);
};

const detachNode = (node, id) => {
  const fun = (e) => e.filter((f) => nodeUtils.getID(f) !== id);
  nodeUtils.modifyConditions(node, fun, true);
};

const attachNode = (nodeReference, nodeDragged, index) => {
  const funAdd = (e) => e.push(nodeDragged);
  const funPosition = (e) => e.splice(index, 0, nodeDragged);
  const fun = (e) => (!index && index !== 0 ? funAdd(e) : funPosition(e));
  nodeUtils.modifyConditions(nodeReference, fun, false);
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, nodeParent, nodeDestinationParent, indexDestination) => {
  const _payload = {
    group: ActionGroupTypes.UPDATE,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node, nodeParent, nodeDestinationParent),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
    uuidDestinationParent: nodeUtils.getUUID(nodeDestinationParent),
    indexDestination: indexDestination,
  };

  return _payload;
};

const generatePayloadDescription = (node, nodeParent, nodeDestinationParent) => {

  return `Move logic '${nodeUtils.getName(node)}' from '${nodeUtils.getName(nodeParent)}' to '${nodeUtils.getName(nodeDestinationParent)}'.`;
}